/**
 * شکلِ آیکونِ تگ‌های ژانر — یک‌بار نوشته، دو بار کشیده.
 *
 * چرا این‌جا و نه توی UI کیتِ هر اپ: تا امروز ۸ دسته‌ی پایه بودن و هر اپ
 * نسخه‌ی خودشو داشت (`apps/web/src/ui/icons.tsx` روی شبکه‌ی ۲۰، مایکروبِ
 * موبایل روی ۲۴). با اومدنِ تگ‌های ژانر (مایگریشن 0064) این عدد شد ۵۳، و
 * «هر شکل دو بار، دستی» یعنی دو ستِ آیکون که از هفته‌ی دوم از هم دور می‌شن.
 * خودِ مسیرِ SVG هیچ‌چیزِ پلتفرمی نداره — یه رشته‌ی مختصاته — پس همون‌جایی
 * می‌شینه که هر دو اپ ازش می‌خونن.
 *
 * شبکه: **۲۴×۲۴**، همون شبکه‌ی ستِ موبایل. (وب برای این شکل‌ها viewBox ۲۴
 * می‌ذاره و قلمشو به همون نسبت ضخیم‌تر می‌کنه؛ ۸ دسته‌ی قدیمی‌ش دست‌نخورده
 * روی ۲۰ می‌مونن — بازکشیدنشون هیچ چیزی اضافه نمی‌کرد جز ریسکِ خراب شدن.)
 *
 * سبک، عیناً همون قاعده‌ی ستِ موجود:
 *  - `body` سیلوئتِ بسته‌ست. حالتِ عادی فقط خط، و حالتِ «انتخاب‌شده» توپُر.
 *  - `lines` جزئیاتِ نازکن که **هیچ‌وقت** پُر نمی‌شن (سیمِ ریسه، دسته‌ی
 *    گرامافون، خطِ استوا). توی حالتِ توپُر روی زمینه‌ی بیرونِ شکل می‌مونن، پس
 *    باید جایی باشن که با خودِ بدنه هم‌پوشانی ندارن — وگرنه دیده نمی‌شن.
 *  - `holes` یعنی «زیرمسیرها سوراخن» (fill-rule evenodd): چشمِ ماسک، خالِ
 *    تاس، سوراخِ سازدهنی. پیش‌فرض خاموشه و آن‌وقت زیرمسیرهای روی هم **یکی**
 *    می‌شن (nonzero) — همون چیزی که برای گیتار (بدنه + دسته + سر) لازمه.
 */

export interface CategoryShape {
  /** سیلوئتِ اصلی؛ در حالتِ انتخاب‌شده پُر می‌شود. */
  body: string;
  /** جزئیاتِ فقط-خطی؛ هیچ‌وقت پُر نمی‌شوند. */
  lines?: string;
  /** زیرمسیرها سوراخ‌اند (evenodd) نه یکی‌شده (nonzero). */
  holes?: boolean;
}

/**
 * شکل‌ها با نامِ **پایه** کلید خورده‌ن، نه با slugِ کاملِ دیتابیس.
 *
 * چون دو تا واژگانِ ژانر در کارن و هر دو یه چیز رو می‌گن: `music-rock`
 * (مایگریشن 0064) و `rock` (واژگانِ هشتگ). با کلیدِ پایه، هر دو به یه شکل
 * می‌رسن و اضافه شدنِ واژگانِ سوم هم فقط یه نگاشتِ تازه می‌خواد، نه ۴۵ تا
 * مسیرِ کپی‌شده.
 */
export const CATEGORY_SHAPES: Record<string, CategoryShape> = {
  // ── موسیقی ──────────────────────────────────────────────────
  /** نتِ چنگ: کله‌ی گرد و دُم و پرچم. */
  music: {
    body: 'M12.6 16.9V4.8L19.4 2.6v3.2L14.6 7.4v9.5z'
      + 'M6.6 16.8a3 3 0 1 0 6 0 3 3 0 1 0-6 0z',
  },
  /** گیتارِ «فلاینگ وی» — بدنه‌ی دوشاخه، دسته و سر. */
  rock: {
    body: 'M13.4 13.1 11.8 10.1 3.4 14.9 5 17.9z'
      + 'M14.2 12.3 11 10.9 6.8 20.3 10 21.7z'
      + 'M13 12 11.8 10.8 19 3.6 20.2 4.8z'
      + 'M18.4 2.4 21.6 5.6 20.2 7 17 3.8z',
  },
  /** میکروفنِ دستی — «خواننده». */
  pop: {
    body: 'M12 3a3.1 3.1 0 0 1 3.1 3.1v4.6a3.1 3.1 0 0 1-6.2 0V6.1A3.1 3.1 0 0 1 12 3z',
    lines: 'M6.4 10.4a5.6 5.6 0 0 0 11.2 0M12 16.2v4M8.6 20.2h6.8',
  },
  /** مویِ تیغ‌ماهی — نشانه‌ی پانک. */
  punk: {
    body: 'M7.8 15.4a4.2 4.2 0 1 0 8.4 0 4.2 4.2 0 1 0-8.4 0z'
      + 'M8.2 12.8 9 7.4l1.5 3.1L12 4.6l1.5 5.9 1.5-3.1.8 5.4z',
  },
  /** دستِ شاخ‌دار — سلامِ متال. */
  metal: {
    body: 'M6.6 11.6h10.8a1.8 1.8 0 0 1 1.8 1.8v3.4a4 4 0 0 1-4 4h-6.4a4 4 0 0 1-4-4v-3.4a1.8 1.8 0 0 1 1.8-1.8z'
      + 'M8.7 4.4a1.4 1.4 0 0 1 1.4 1.4v6.6H7.3V5.8a1.4 1.4 0 0 1 1.4-1.4z'
      + 'M15.3 4.4a1.4 1.4 0 0 1 1.4 1.4v6.6h-2.8V5.8a1.4 1.4 0 0 1 1.4-1.4z',
  },
  /** ویولن: کاسه‌ی کمردار و دسته. سوراخ‌های f خطی‌ان. */
  classical: {
    body: 'M12 5.4c2.6 0 4.4 1.6 4.4 3.5 0 2-2.1 2.4-2.1 3.3s2.5 1.5 2.5 4.1c0 2.7-2.1 4.7-4.8 4.7s-4.8-2-4.8-4.7c0-2.6 2.5-3.2 2.5-4.1s-2.1-1.3-2.1-3.3c0-1.9 1.8-3.5 4.4-3.5z'
      + 'M10.9 2.2h2.2v3.6h-2.2z',
    lines: 'M9.4 14.4v2.8M14.6 14.4v2.8',
  },
  /** ساکسیفون: لوله‌ی خمیده و کاسه‌ی پهن. */
  jazz: {
    body: 'M10.2 2.6h3.2v9.6c0 1.5-.7 2.3-.7 3.4 0 1.4 1.1 2.4 2.7 2.4h1.2v3.2h-1.2c-3.5 0-5.9-2.3-5.9-5.6 0-2 .7-2.9.7-4.1V2.6z'
      + 'M15.4 16.4h5.8l-1.4 5.2h-4.4z',
    lines: 'M11 6.4h2.6M11 9.2h2.6',
  },
  /** سازدهنی: قابِ کشیده با سوراخ‌های ردیفی. */
  blues: {
    body: 'M4 9.2h16a1.4 1.4 0 0 1 1.4 1.4v3.2a1.4 1.4 0 0 1-1.4 1.4H4a1.4 1.4 0 0 1-1.4-1.4v-3.2A1.4 1.4 0 0 1 4 9.2z'
      + 'M5.6 11.2h1.8v2H5.6z M8.6 11.2h1.8v2H8.6z M11.6 11.2h1.8v2h-1.8z'
      + 'M14.6 11.2h1.8v2h-1.8z M17.6 11.2h1.8v2h-1.8z',
    holes: true,
  },
  /** بانجو: کاسه‌ی گرد با دهانه، و دسته‌ی بلند. */
  folk: {
    body: 'M4 15.4a5 5 0 1 0 10 0 5 5 0 1 0-10 0z'
      + 'M7.3 15.4a1.7 1.7 0 1 0 3.4 0 1.7 1.7 0 1 0-3.4 0z'
      + 'M12.4 12.1 13.5 11 19.9 4.6 21 5.7z',
    holes: true,
  },
  /** کلاهِ کابویی. */
  country: {
    body: 'M2.8 16.4c0-1.2 3.8-2.2 9.2-2.2s9.2 1 9.2 2.2-4.1 2.4-9.2 2.4-9.2-1.2-9.2-2.4z'
      + 'M7.4 15.6 8.6 7.4C8.8 6 10 5.2 12 5.2s3.2.8 3.4 2.2l1.2 8.4c-1.5-.5-3.2-.7-4.6-.7s-3.1.2-4.6.5z',
  },
  /** گرامافون: صفحه، سوراخِ وسط، و بازوی صدا. */
  hiphop: {
    body: 'M4.6 13.4a7.4 7.4 0 1 0 14.8 0 7.4 7.4 0 1 0-14.8 0z'
      + 'M10.7 13.4a1.3 1.3 0 1 0 2.6 0 1.3 1.3 0 1 0-2.6 0z',
    lines: 'M21.4 3.6 15.8 9.2',
    holes: true,
  },
  /** کلاویه‌ی پیانو — کلیدهای سیاه سوراخ‌ان. */
  rnb: {
    body: 'M4.6 6.8h14.8a1.4 1.4 0 0 1 1.4 1.4v7.6a1.4 1.4 0 0 1-1.4 1.4H4.6a1.4 1.4 0 0 1-1.4-1.4V8.2a1.4 1.4 0 0 1 1.4-1.4z'
      + 'M7.2 6.8h1.8v5.4H7.2z M10.4 6.8h1.8v5.4h-1.8z'
      + 'M13.6 6.8h1.8v5.4h-1.8z M16.8 6.8h1.8v5.4h-1.8z',
    holes: true,
  },
  /** میکسر: دو ریلِ کشویی با دو دستگیره. */
  electronic: {
    body: 'M6.6 8.4a2.4 2.4 0 1 0 4.8 0 2.4 2.4 0 1 0-4.8 0z'
      + 'M12.6 15.6a2.4 2.4 0 1 0 4.8 0 2.4 2.4 0 1 0-4.8 0z',
    lines: 'M3.4 8.4h3M11.6 8.4h9M3.4 15.6h9M17.6 15.6h3',
  },
  /** کره‌ی زمین: نصف‌النهارِ سوراخ‌شده و خطِ استوا. */
  world: {
    body: 'M3.6 12a8.4 8.4 0 1 0 16.8 0 8.4 8.4 0 1 0-16.8 0z'
      + 'M12 3.6a3.6 8.4 0 1 0 0 16.8 3.6 8.4 0 1 0 0-16.8z',
    lines: 'M4 9.4h16M4 14.6h16',
    holes: true,
  },

  // ── ورزش ────────────────────────────────────────────────────
  /** توپِ بسکتبال — درزهاش خطی‌ان. */
  basketball: {
    body: 'M3.6 12a8.4 8.4 0 1 0 16.8 0 8.4 8.4 0 1 0-16.8 0z',
    lines: 'M3.6 12h16.8M12 3.6v16.8M6.1 6.1a11.4 11.4 0 0 1 0 11.8M17.9 6.1a11.4 11.4 0 0 0 0 11.8',
  },
  /** دروازه و توپ — «فوتبال»، تا با توپِ دسته‌ی ورزش یکی نشه. */
  soccer: {
    body: 'M2.8 7.8h14.4v10.4h-2V9.8H4.8v8.4h-2z'
      + 'M15.8 17.4a2.9 2.9 0 1 0 5.8 0 2.9 2.9 0 1 0-5.8 0z',
    lines: 'M7.6 9.8v8.4M12.4 9.8v8.4M4.8 12.6h10.4M4.8 15.4h10.4',
  },
  /** توپِ فوتبالِ آمریکایی — بندهاش سوراخ‌ان تا توی حالتِ توپُر هم بمونن. */
  football: {
    body: 'M3 12c3-3.8 6-5.7 9-5.7s6 1.9 9 5.7c-3 3.8-6 5.7-9 5.7s-6-1.9-9-5.7z'
      + 'M9.2 11.5h5.6v1h-5.6z'
      + 'M10.2 10h.9v4h-.9z M11.9 10h.9v4h-.9z M13.6 10h.9v4h-.9z',
    holes: true,
  },
  /** چوب و توپِ هاکی. */
  hockey: {
    body: 'M7 18.6 8.2 17.6 18.8 5.2 19.9 6.2z'
      + 'M3.4 17.6h5.4a1.1 1.1 0 0 1 0 2.2H3.4a1.1 1.1 0 0 1 0-2.2z'
      + 'M16.4 19.2a2.6 1.3 0 1 0 5.2 0 2.6 1.3 0 1 0-5.2 0z',
  },
  /** آدمِ دونده. */
  running: {
    body: 'M15.6 2.6a2.1 2.1 0 1 0 0 4.2 2.1 2.1 0 1 0 0-4.2z'
      + 'M13.6 7.6 8.2 9.8a2 2 0 0 0-1 .8l-2.4 3.6 1.8 1.2 2.1-3.2 2.4-1-1.2 3.6a2 2 0 0 0 .5 2l3.3 3.1.9 4.1 2.1-.5-1-4.6a2 2 0 0 0-.6-1.1l-2.5-2.3 1.6-4.5 1.2 2.4a2 2 0 0 0 1.8 1.1h3v-2.2h-2.6l-2-4a2 2 0 0 0-2-1.1z',
  },
  /** دو بازو و دستِ گره‌خورده روی میز — مچ‌اندازی. */
  wrestling: {
    body: 'M8.6 20.5 6.2 19.5 9.8 10.1 12.2 11.1z'
      + 'M15.4 20.5 17.8 19.5 14.2 10.1 11.8 11.1z'
      + 'M9.4 6.8h5.2a2.2 2.2 0 0 1 2.2 2.2v2.6a2.2 2.2 0 0 1-2.2 2.2H9.4a2.2 2.2 0 0 1-2.2-2.2V9a2.2 2.2 0 0 1 2.2-2.2z',
    lines: 'M2.8 21h18.4',
  },

  // ── هنر ─────────────────────────────────────────────────────
  /** پالتِ نقاشی — رنگ‌ها و جای انگشت سوراخ‌ان. */
  arts: {
    body: 'M12 2.8c5.1 0 9.2 3.6 9.2 8 0 2.7-2 3.8-3.7 3.8h-2c-1.3 0-2.3.9-2.3 2 0 .5.2.9.4 1.3.2.4.4.7.4 1.1 0 1.1-1 2-2.3 2-5 0-9-4.1-9-9.2 0-5 4.1-9 9.3-9z'
      + 'M6.8 11.4a1.3 1.3 0 1 0 2.6 0 1.3 1.3 0 1 0-2.6 0z'
      + 'M7.9 7.2a1.3 1.3 0 1 0 2.6 0 1.3 1.3 0 1 0-2.6 0z'
      + 'M12.3 5.9a1.3 1.3 0 1 0 2.6 0 1.3 1.3 0 1 0-2.6 0z'
      + 'M15.9 8.6a1.3 1.3 0 1 0 2.6 0 1.3 1.3 0 1 0-2.6 0z',
    holes: true,
  },
  /** پرده‌ی صحنه. */
  theatre: {
    body: 'M3 3.2h18v2.6H3z'
      + 'M4.4 6.2c2.8 1.7 3.6 5.8 2.1 9.7-.7 1.9-.6 3.5.4 4.9H4.4z'
      + 'M19.6 6.2c-2.8 1.7-3.6 5.8-2.1 9.7.7 1.9.6 3.5-.4 4.9h2.5z',
  },
  /** کلاهِ بلند و عصا — تئاترِ موزیکال. */
  musical: {
    body: 'M8.6 3.4h6.8a1 1 0 0 1 1 1v9.2H7.6V4.4a1 1 0 0 1 1-1z'
      + 'M4.2 13.8h15.6a1.1 1.1 0 0 1 0 2.4H4.2a1.1 1.1 0 0 1 0-2.4z',
    lines: 'M4.6 21.4 13 17.2M13 17.2a1.8 1.8 0 0 1 2.8 1.6',
  },
  /** صورتِ خندان — دهانِ باز سوراخه. */
  comedy: {
    body: 'M3.6 12a8.4 8.4 0 1 0 16.8 0 8.4 8.4 0 1 0-16.8 0z'
      + 'M6.8 12.8h10.4a5.2 5.2 0 0 1-10.4 0z',
    lines: 'M7.6 9.4a1.8 1.8 0 0 1 3 0M13.4 9.4a1.8 1.8 0 0 1 3 0',
    holes: true,
  },
  /** آدمِ در حالِ رقص. */
  dance: {
    body: 'M14.8 2.4a2 2 0 1 0 0 4 2 2 0 1 0 0-4z'
      + 'M13.4 7.2a2 2 0 0 0-1.8 1.1l-2.3 4.4-3.9 1.4.7 2.1 4.4-1.6a2 2 0 0 0 1.1-1l.7-1.3.6 2.6-4 5.7 1.8 1.3 4.3-6.2a2 2 0 0 0 .3-1.6l-.8-3.4 2.4 2.3 3.4-1.3-.7-2.1-2.3.9-2.6-2.5a2 2 0 0 0-1.3-.8z',
  },
  /** دوربینِ اپرا — دو حلقه که وسطشون سوراخه. */
  opera: {
    body: 'M3.6 11.6a4.2 4.2 0 1 0 8.4 0 4.2 4.2 0 1 0-8.4 0z'
      + 'M5.6 11.6a2.2 2.2 0 1 0 4.4 0 2.2 2.2 0 1 0-4.4 0z'
      + 'M12 11.6a4.2 4.2 0 1 0 8.4 0 4.2 4.2 0 1 0-8.4 0z'
      + 'M14 11.6a2.2 2.2 0 1 0 4.4 0 2.2 2.2 0 1 0-4.4 0z',
    lines: 'M18.6 15 21 20.6',
    holes: true,
  },
  /** نورافکن روی اجراگر — خودِ اجراگر سوراخِ وسطِ نوره. */
  'performance-art': {
    body: 'M9.4 2.4h5.2v2.6H9.4z'
      + 'M9.2 5.6h5.6l5.2 15.6H4z'
      + 'M12 14.4a2.2 2.2 0 1 0 0 4.4 2.2 2.2 0 1 0 0-4.4z',
    holes: true,
  },
  /** تابلوی قاب‌شده. */
  exhibition: {
    body: 'M3.4 4.6h17.2a1.2 1.2 0 0 1 1.2 1.2v12.4a1.2 1.2 0 0 1-1.2 1.2H3.4a1.2 1.2 0 0 1-1.2-1.2V5.8a1.2 1.2 0 0 1 1.2-1.2z'
      + 'M4.8 7h14.4v10H4.8z'
      + 'M6.2 16 10 11l2.4 3 1.8-2.2 3.6 4.2z'
      + 'M15.4 8.2a1.3 1.3 0 1 0 0 2.6 1.3 1.3 0 1 0 0-2.6z',
    holes: true,
  },
  /** کلاکتِ فیلم‌برداری — نوارهای کجش سوراخ‌ان. */
  film: {
    body: 'M2.6 9.6h18.8a1 1 0 0 1 1 1v8.4a1 1 0 0 1-1 1H2.6a1 1 0 0 1-1-1v-8.4a1 1 0 0 1 1-1z'
      + 'M2.6 4.4h18.8v3.8H2.6z'
      + 'M5.4 4.4 7.6 4.4 5 8.2 2.8 8.2z'
      + 'M10 4.4 12.2 4.4 9.6 8.2 7.4 8.2z'
      + 'M14.6 4.4 16.8 4.4 14.2 8.2 12 8.2z'
      + 'M19.2 4.4 21.4 4.4 18.8 8.2 16.6 8.2z',
    holes: true,
  },
  /** پَر. */
  indigenous: {
    body: 'M18.4 2.6c1 5.6-.6 10.2-4 12.8-2.2 1.7-4.6 2.2-6.6 2.1l-2.6 2.6-1.6-1.6 2.6-2.6c-.4-2.4 0-5.2 1.6-7.6C10.2 4.6 13.6 2.8 18.4 2.6z',
    lines: 'M16.4 5.2 9.6 12M17.4 9.2l-5.8 5.8M15 3.6 8.2 10.4',
  },

  // ── اجتماعی ─────────────────────────────────────────────────
  /** سه نفر. */
  community: {
    body: 'M9.6 6.6a2.4 2.4 0 1 0 4.8 0 2.4 2.4 0 1 0-4.8 0z'
      + 'M4.2 13.4a2.2 2.2 0 1 0 4.4 0 2.2 2.2 0 1 0-4.4 0z'
      + 'M15.4 13.4a2.2 2.2 0 1 0 4.4 0 2.2 2.2 0 1 0-4.4 0z',
    lines: 'M7.8 13a4.4 4.4 0 0 1 8.4 0M2.4 19.8a4.2 4.2 0 0 1 8 0M13.6 19.8a4.2 4.2 0 0 1 8 0',
  },
  /** ریسه‌ی پرچم — جشنواره. */
  festival: {
    body: 'M3.4 6.2 7.6 5.8 5.6 11.4z M8.8 5.6 13 5.6 11 11.2z M14.2 5.8 18.4 6.4 16.4 11.8z',
    lines: 'M2 5.2c3.6-1.8 16.4-1.4 20 1.4',
  },
  /** سبدِ خرید — بازارچه. */
  market: {
    body: 'M2.8 8.4h18.4l-1.9 10.8a1.8 1.8 0 0 1-1.8 1.4H6.5a1.8 1.8 0 0 1-1.8-1.4z',
    lines: 'M8.2 8.4 10.6 3M15.8 8.4 13.4 3',
  },
  /** چرخ‌وفلک. */
  fair: {
    body: 'M4 10.6a8 8 0 1 0 16 0 8 8 0 1 0-16 0z'
      + 'M10.4 10.6a1.6 1.6 0 1 0 3.2 0 1.6 1.6 0 1 0-3.2 0z',
    lines: 'M12 2.6v16M4 10.6h16M6.4 5 17.6 16.2M17.6 5 6.4 16.2M12 12.2 7 21.4M12 12.2l5 9.2M6.6 21.4h10.8',
    holes: true,
  },
  /** بزرگ‌تر و کوچک‌تر — خانوادگی. */
  family: {
    body: 'M8 3a2.5 2.5 0 1 0 0 5 2.5 2.5 0 1 0 0-5z'
      + 'M4.2 20.8v-5.4a3.8 3.8 0 0 1 7.6 0v5.4z'
      + 'M16.6 8.2a2 2 0 1 0 0 4 2 2 0 1 0 0-4z'
      + 'M13.6 20.8v-4.2a3 3 0 0 1 6 0v4.2z',
  },
  /** کلاهِ فارغ‌التحصیلی. */
  education: {
    body: 'M12 3.8 22.4 8.6 12 13.4 1.6 8.6z'
      + 'M6.6 11.4 12 13.9 17.4 11.4v4.4c0 1.8-2.4 3.2-5.4 3.2s-5.4-1.4-5.4-3.2z',
    lines: 'M20.4 9.4v5.2',
  },
  /** چکش — کارگاه. */
  workshop: {
    body: 'M12.6 3.4 20.8 7.4 19 11 10.8 7z'
      + 'M14.2 8.9 12.6 8 5.6 20 7.2 20.9z',
  },
  /** تریبون و سخنران — همایش. */
  conference: {
    body: 'M12 2.4a2.2 2.2 0 1 0 0 4.4 2.2 2.2 0 1 0 0-4.4z'
      + 'M7.2 8.4h9.6v2.2H7.2z'
      + 'M8.4 11.6h7.2l1.6 9.4H6.8z',
    lines: 'M19 8.6a2.6 2.6 0 0 1 0 5.2M21 7.4a4.6 4.6 0 0 1 0 7.6',
  },
  /** درخشش — مناسبتی. */
  holiday: {
    body: 'M11 2.2c.9 4.8 2.3 6.2 7 7-4.7.9-6.1 2.3-7 7-.9-4.7-2.3-6.1-7-7 4.7-.8 6.1-2.2 7-7z'
      + 'M18.4 14.4c.4 2.4 1.2 3.1 3.6 3.6-2.4.4-3.2 1.2-3.6 3.6-.5-2.4-1.2-3.2-3.6-3.6 2.4-.5 3.1-1.2 3.6-3.6z',
  },
  /** نیلوفرِ فرانسوی. */
  francophone: {
    body: 'M12 1.8c1.9 2.6 2.6 4.7 2.2 6.6 1-1.4 2.7-2 4.2-1.2 1.9 1.1 1.9 3.9 0 5.3-1.3 1-3 1.2-4.5.6v1.5h2.3v2.1h-2.3v5.5h-3.8v-5.5H7.8v-2.1h2.3v-1.5c-1.5.6-3.2.4-4.5-.6-1.9-1.4-1.9-4.2 0-5.3 1.5-.8 3.2-.2 4.2 1.2-.4-1.9.3-4 2.2-6.6z',
  },

  // ── شب‌گردی ─────────────────────────────────────────────────
  /** ماه و ستاره. */
  nightlife: {
    body: 'M14.6 3.2a8.8 8.8 0 1 0 6.2 13.4 7.2 7.2 0 0 1-6.2-13.4z'
      + 'M5.4 2.6 6.2 5l2.4.8-2.4.8-.8 2.4-.8-2.4-2.4-.8L4.6 5z',
  },
  /** گویِ دیسکو — وجه‌هاش سوراخ‌ان. */
  club: {
    body: 'M5.4 11.4a6.6 6.6 0 1 0 13.2 0 6.6 6.6 0 1 0-13.2 0z'
      + 'M9.2 9h2.2v2.2H9.2z M12.6 9h2.2v2.2h-2.2z'
      + 'M9.2 12.2h2.2v2.2H9.2z M12.6 12.2h2.2v2.2h-2.2z',
    lines: 'M12 4.8V2.2M3.4 19.6l1.8-1.8M20.6 19.6l-1.8-1.8',
    holes: true,
  },
  /** ترقه و کاغذرنگی — پارتی. */
  party: {
    body: 'M2.6 21.4 9.6 9.2l5.2 5.2z'
      + 'M15.8 5a1.1 1.1 0 1 0 2.2 0 1.1 1.1 0 1 0-2.2 0z'
      + 'M18.8 9.2a1.1 1.1 0 1 0 2.2 0 1.1 1.1 0 1 0-2.2 0z'
      + 'M13.4 2.2a1 1 0 1 0 2 0 1 1 0 1 0-2 0z'
      + 'M20 3.6a1 1 0 1 0 2 0 1 1 0 1 0-2 0z',
  },

  // ── بازی ────────────────────────────────────────────────────
  /** جوی‌استیک. */
  arcade: {
    body: 'M12 2.4a2.9 2.9 0 1 0 0 5.8 2.9 2.9 0 1 0 0-5.8z'
      + 'M10.8 8h2.4v8.4h-2.4z'
      + 'M4.8 16.2h14.4a2.2 2.2 0 0 1 2.2 2.2v1.2a1.4 1.4 0 0 1-1.4 1.4H4a1.4 1.4 0 0 1-1.4-1.4v-1.2a2.2 2.2 0 0 1 2.2-2.2z',
  },
  /** مهره‌ی شطرنج — بازیِ رومیزی. */
  boardgames: {
    body: 'M12 2.4a3.1 3.1 0 0 1 2 5.5c1.1.9 1.8 2.1 1.8 3.5 0 1.6-.9 3-2.2 3.8l1.3 4.4h2.3v2.2H6.8v-2.2h2.3l1.3-4.4c-1.3-.8-2.2-2.2-2.2-3.8 0-1.4.7-2.6 1.8-3.5a3.1 3.1 0 0 1 2-5.5z',
  },

  // ── ورزش‌های واژگانِ هشتگ ────────────────────────────────────
  /** جامِ قهرمانی — سرشاخه‌ی ورزش. */
  sports: {
    body: 'M7.4 3.4h9.2v5.4a4.6 4.6 0 0 1-9.2 0z'
      + 'M10.8 13.2h2.4v4h-2.4z'
      + 'M7 17h10v3.4H7z',
    lines: 'M7.4 5.2H5.2a2.6 2.6 0 0 0 2.6 4.4M16.6 5.2h2.2a2.6 2.6 0 0 1-2.6 4.4',
  },
  /** توپِ والیبال — نوارهای خمیده، تا با بسکتبال یکی نشه. */
  volleyball: {
    body: 'M3.6 12a8.4 8.4 0 1 0 16.8 0 8.4 8.4 0 1 0-16.8 0z',
    lines: 'M12 3.6c-3.2 3.6-4.4 7.8-3.4 12.4M20.2 10.2c-4.6-.6-8.6.8-11.8 4.2M7 18.8c1.4-4.4 4.4-7.4 8.8-9',
  },
  /** دروازه‌ی راگبی و توپِ بیضی. */
  rugby: {
    body: 'M4.4 4.6h1.9v16.2H4.4z M17.7 4.6h1.9v16.2h-1.9z M4.4 7.6h15.2v1.9H4.4z'
      + 'M8.4 17.2c1.2-1.6 2.4-2.4 3.6-2.4s2.4.8 3.6 2.4c-1.2 1.6-2.4 2.4-3.6 2.4s-2.4-.8-3.6-2.4z',
  },
  /** چوب و توپِ بیسبال. */
  baseball: {
    body: 'M19 3.4a1.9 1.9 0 0 1 1.6 1.6c0 .5-.2 1-.6 1.4L9.6 16.8l-2.4-2.4L17.6 4c.4-.4.9-.6 1.4-.6z'
      + 'M6.4 15.6 8.4 17.6l-3 3-2-2z'
      + 'M16.6 18a2.8 2.8 0 1 0 5.6 0 2.8 2.8 0 1 0-5.6 0z',
  },
  /** لباسِ رزمی با کمربند — یقه و کمربند سوراخ‌ان. */
  'martial-arts': {
    body: 'M8.6 3.4 12 6.2 15.4 3.4 20.2 5.8v14.8H3.8V5.8z'
      + 'M11.2 7.2 8.8 5.2 7.4 6.6l3.4 3z'
      + 'M12.8 7.2 15.2 5.2l1.4 1.4-3.4 3z'
      + 'M3.8 12.4h16.4v2.6H3.8z',
    holes: true,
  },
  /** کفشِ اسکیت. */
  skating: {
    body: 'M6.2 3.4h4.2v7.2c0 1.6 1 2.6 3 3.2l4.4 1.6c1.4.6 2 1.4 2 2.6H6.2z',
    lines: 'M4.2 20.4h15.8M7.4 20.4v-1.4M17.4 20.4v-1.4',
  },
  /** پرچمِ شطرنجی — موتوراسپرت. */
  motorsports: {
    body: 'M6 4h13.4v8.4H6z'
      + 'M6 4h3.35v2.8H6z M12.7 4h3.35v2.8H12.7z'
      + 'M9.35 6.8h3.35v2.8H9.35z M16.05 6.8h3.35v2.8h-3.35z'
      + 'M6 9.6h3.35v2.8H6z M12.7 9.6h3.35v2.8H12.7z',
    lines: 'M4.8 3v18',
    holes: true,
  },
  /** دوچرخه — دو حلقه و قاب. */
  cycling: {
    body: 'M1.6 15.6a4 4 0 1 0 8 0 4 4 0 1 0-8 0z'
      + 'M3.6 15.6a2 2 0 1 0 4 0 2 2 0 1 0-4 0z'
      + 'M14.4 15.6a4 4 0 1 0 8 0 4 4 0 1 0-8 0z'
      + 'M16.4 15.6a2 2 0 1 0 4 0 2 2 0 1 0-4 0z',
    lines: 'M5.6 15.6 9.8 7.6h5.2l3.4 8M9.4 7.6h4.4M12.6 15.6 15 7.6',
    holes: true,
  },
  /** دمبل. */
  fitness: {
    body: 'M8.6 10.6h6.8v2.8H8.6z'
      + 'M4.8 8.4h2.8v7.2H4.8z M16.4 8.4h2.8v7.2h-2.8z'
      + 'M2.4 10h1.8v4H2.4z M19.8 10h1.8v4h-1.8z'
      + 'M7.2 10h1.8v4H7.2z M15 10h1.8v4H15z',
  },
  /** یوگا — نشستنِ چهارزانو. */
  'yoga-wellness': {
    body: 'M12 2.6a2.4 2.4 0 1 0 0 4.8 2.4 2.4 0 1 0 0-4.8z'
      + 'M12 8.4c2 0 3.4 1.4 3.4 3.4v1.6l3.6 1.6-1 2.2-4-1.8h-4l-4 1.8-1-2.2 3.6-1.6v-1.6c0-2 1.4-3.4 3.4-3.4z'
      + 'M6.4 18.4h11.2v2.4H6.4z',
  },

  // ── خوراک و نوشیدنی ─────────────────────────────────────────
  /** چنگال و چاقو. */
  'food-drink': {
    body: 'M7 3h1.4v4.6h.9V3h1.4v4.6h.9V3h1.4v5.4c0 1.3-.8 2.2-2 2.5V21H8.9V10.9c-1.2-.3-1.9-1.2-1.9-2.5z'
      + 'M16.4 3c1.7 1.5 2.6 3.8 2.6 6.8 0 2-.6 3.4-1.7 4.2V21h-1.8z',
  },
  /** لیوانِ آبجو با کف. */
  beer: {
    body: 'M5.4 6.8h9.2v12a2.2 2.2 0 0 1-2.2 2.2H7.6a2.2 2.2 0 0 1-2.2-2.2z'
      + 'M5.4 7c0-2.2 1.5-3.6 3.4-3.6.9 0 1.7.3 2.3.9.5-.5 1.2-.8 2-.8 1.7 0 3 1.3 3 3 0 .2 0 .4-.1.5z',
    lines: 'M14.8 9.4h2a2.2 2.2 0 0 1 0 4.4h-2',
  },
  /** گیلاسِ شراب. */
  wine: {
    body: 'M7.4 3.4h9.2l-.6 5.4a4.1 4.1 0 0 1-8 0z'
      + 'M11.2 12.4h1.6v6.4h-1.6z'
      + 'M7.6 18.8h8.8v1.8H7.6z',
  },
  /** گیلاسِ کوکتل. */
  cocktails: {
    body: 'M4.6 4.6h14.8L12.8 12h-1.6z'
      + 'M11.2 12h1.6v6.8h-1.6z'
      + 'M7.8 18.8h8.4v1.8H7.8z'
      + 'M17.6 2.4a1.4 1.4 0 1 0 2.8 0 1.4 1.4 0 1 0-2.8 0z',
    lines: 'M19 3.8 15.4 8',
  },

  // ── دانش، کتاب، آدم‌ها ──────────────────────────────────────
  /** کتاب‌های روی هم. */
  books: {
    body: 'M6.4 4.4h11.2a1 1 0 0 1 1 1v1.8a1 1 0 0 1-1 1H6.4a1 1 0 0 1-1-1V5.4a1 1 0 0 1 1-1z'
      + 'M5.4 9.4h13.2a1 1 0 0 1 1 1v1.8a1 1 0 0 1-1 1H5.4a1 1 0 0 1-1-1v-1.8a1 1 0 0 1 1-1z'
      + 'M4.4 14.4h15.2a1 1 0 0 1 1 1v1.8a1 1 0 0 1-1 1H4.4a1 1 0 0 1-1-1v-1.8a1 1 0 0 1 1-1z',
  },
  /** کتابِ باز — قصه‌گویی. */
  storytelling: {
    body: 'M12 6.6C10 5 7.6 4.4 4.4 4.4v12.4c3.2 0 5.6.6 7.6 2.2 2-1.6 4.4-2.2 7.6-2.2V4.4c-3.2 0-5.6.6-7.6 2.2z',
    lines: 'M12 6.6v12.4',
  },
  /** بوته‌ی آزمایش — علم. */
  science: {
    body: 'M10 3.6h4v5.2l5.4 9.2a1.8 1.8 0 0 1-1.6 2.8H6.2a1.8 1.8 0 0 1-1.6-2.8L10 8.8z'
      + 'M10.4 15a1.1 1.1 0 1 0 2.2 0 1.1 1.1 0 1 0-2.2 0z'
      + 'M13.4 17.8a.9.9 0 1 0 1.8 0 .9.9 0 1 0-1.8 0z',
    holes: true,
  },
  /** ریزتراشه — فناوری. */
  tech: {
    body: 'M7.4 7.4h9.2v9.2H7.4z M10 10h4v4h-4z',
    lines: 'M9.6 7.4V4.8M12 7.4V4.8M14.4 7.4V4.8M9.6 16.6v2.6M12 16.6v2.6M14.4 16.6v2.6'
      + 'M7.4 9.6H4.8M7.4 12H4.8M7.4 14.4H4.8M16.6 9.6h2.6M16.6 12h2.6M16.6 14.4h2.6',
    holes: true,
  },
  /** حبابِ گفتگو با ستاره — انیمه و کمیک. */
  'anime-comics': {
    body: 'M4.4 4.4h15.2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-8.6l-4.8 4.2V16.4H4.4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2z'
      + 'M12 6.6 13.1 9.2l2.8.2-2.1 1.9.6 2.7L12 12.6l-2.4 1.4.6-2.7-2.1-1.9 2.8-.2z',
    holes: true,
  },
  /** آدم با عصا — سالمندان. */
  seniors: {
    body: 'M9.6 2.6a2.3 2.3 0 1 0 0 4.6 2.3 2.3 0 1 0 0-4.6z'
      + 'M6.6 20.8v-7.4a3 3 0 0 1 6 0v7.4z',
    lines: 'M16.6 10.4v10.4M16.6 10.4a1.8 1.8 0 0 0-2.8 0',
  },
  /** سرِ آدم با قلب — سلامتِ روان. */
  'mental-health': {
    body: 'M12 2.8c4.4 0 8 3.4 8 7.8 0 2.2-.9 3.8-2 5-.6.7-.8 1.1-.8 1.9v3.7H8.6v-2.6c0-1-.5-1.5-1.3-2.2C5.8 15 4.8 13 4.8 10.6c0-4.4 3.4-7.8 7.2-7.8z'
      + 'M12.2 9.4c.9-1.5 3.2-.9 3.2 1 0 1.4-1.7 2.7-3.2 3.8-1.5-1.1-3.2-2.4-3.2-3.8 0-1.9 2.3-2.5 3.2-1z',
    holes: true,
  },

  // ── چیزهای دیگر ─────────────────────────────────────────────
  /** کفشِ پاشنه‌بلند — درگ. */
  drag: {
    body: 'M5 5.6h2.8v7c0 1.6 1 2.6 3 3.2l8.2 2.6c1.4.4 2 1.2 2 2.6v.6h-11c-3.6 0-5-2-5-5.4z',
  },
  /** پرچمِ رنگین‌کمان. */
  'pride-lgbtq': {
    body: 'M5.6 3.6h14.8v11.2H5.6z'
      + 'M5.6 5.5h14.8v1.9H5.6z M5.6 9.2h14.8v1.9H5.6z M5.6 12.9h14.8v1.9H5.6z',
    lines: 'M4.6 3v18.4',
    holes: true,
  },
  /** چادرِ سیرک. */
  circus: {
    body: 'M12 3.4c5 0 9 3.2 9.4 7H2.6C3 6.6 7 3.4 12 3.4z'
      + 'M2.6 10.4h18.8L19.8 20.6H4.2z'
      + 'M12 12.4c1.9 2.1 2.9 5.2 2.9 8.2H9.1c0-3 1-6.1 2.9-8.2z',
    lines: 'M12 3.4V1.6',
    holes: true,
  },
  /** عصای جادو و درخشش. */
  magic: {
    body: 'M5.4 20.8 3.2 18.6 14.6 7.2l2.2 2.2z'
      + 'M17.4 2.6 18.9 5.9l3.3 1.5-3.3 1.5-1.5 3.3-1.5-3.3-3.3-1.5 3.3-1.5z',
  },
  /** گلوله‌ی کاموا و سوزن — صنایعِ دستی. */
  crafts: {
    body: 'M4.6 14a5.6 5.6 0 1 0 11.2 0 5.6 5.6 0 1 0-11.2 0z',
    lines: 'M6.2 10.6c3 1.6 5.2 4.4 6 7.8M8.8 8.8c1.7 3.4 1.9 7.1.7 10.4M13.4 9.6c1.5 2.6 1.7 5.5.7 8.2'
      + 'M15.4 10 21 4.4M18.8 2.6l2.6 2.6',
  },
  /** چادرِ کمپ — طبیعت‌گردی. */
  outdoors: {
    body: 'M12 4 21.6 20.6H2.4z M12 11.6 15.2 20.6H8.8z',
    holes: true,
  },
  /** گلدان — باغبانی. */
  gardening: {
    body: 'M6.4 14.6h11.2l-1.4 6.2H7.8z'
      + 'M11.6 14.2c-3.4 0-5.6-2-5.6-4.8 3.1 0 5.6 1.8 5.6 4.8z'
      + 'M12.4 14.2c0-3.7 1.9-6.6 4.8-7.6.6 3.9-1.5 7.2-4.8 7.6z',
  },
  /** تابلوی راهنما — گشت. */
  tour: {
    body: 'M11.2 5.4h1.6v15.4h-1.6z'
      + 'M4.2 5.4h10.6l2 2.2-2 2.2H4.2z'
      + 'M19.8 11.6H9.2l-2 2.2 2 2.2h10.6z',
  },
  /** خودرو. */
  cars: {
    body: 'M4.6 12.6 6.5 7.4a2 2 0 0 1 1.9-1.4h7.2a2 2 0 0 1 1.9 1.4l1.9 5.2v5a1 1 0 0 1-1 1h-1.7a1 1 0 0 1-1-1v-1H8.3v1a1 1 0 0 1-1 1H5.6a1 1 0 0 1-1-1z'
      + 'M7.6 11.6 8.9 8h6.2l1.3 3.6z'
      + 'M6.7 14.9a1.2 1.2 0 1 0 2.4 0 1.2 1.2 0 1 0-2.4 0z'
      + 'M14.9 14.9a1.2 1.2 0 1 0 2.4 0 1.2 1.2 0 1 0-2.4 0z',
    holes: true,
  },
  /** گویِ بلورین — فال و رازآلود. */
  psychic: {
    body: 'M6 10.4a6 6 0 1 0 12 0 6 6 0 1 0-12 0z'
      + 'M11.4 6.6 12.2 8.8l2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8z'
      + 'M6.6 17.2h10.8l1.6 3.4H5z',
    holes: true,
  },
  /** هدستِ واقعیتِ مجازی — ایمرسیو. */
  immersive: {
    body: 'M4 8h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4.6l-1.4-1.8h-4L8.6 16H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2z'
      + 'M5.6 10.4h4.2v3.2H5.6z M14.2 10.4h4.2v3.2h-4.2z',
    lines: 'M4.4 8V6.6M19.6 8V6.6',
    holes: true,
  },
  /** قلب روی دستِ باز — خیریه. */
  charity: {
    body: 'M12 6.6c1.8-3 6.4-1.8 6.4 2 0 3-3.6 5.6-6.4 7.6-2.8-2-6.4-4.6-6.4-7.6 0-3.8 4.6-5 6.4-2z',
    lines: 'M3.6 20.8c1.8-2.8 4.8-4.4 8.4-4.4s6.6 1.6 8.4 4.4',
  },
  /** درختِ کاج — کریسمس. */
  christmas: {
    body: 'M12 2.6 16.4 9h-2.6l3.4 5.2h-2.8L18 19.4H6l3.6-5.2H6.8L10.2 9H7.6z'
      + 'M10.8 19.4h2.4v2.2h-2.4z',
  },
  /** کدو با صورت — هالووین. */
  halloween: {
    body: 'M12 6.6c1.4-1.4 3.4-1.8 5-.8 2 1.2 3 3.8 3 6.6 0 4.4-2.6 8-6 8-.7 0-1.4-.2-2-.5-.6.3-1.3.5-2 .5-3.4 0-6-3.6-6-8 0-2.8 1-5.4 3-6.6 1.6-1 3.6-.6 5 .8z'
      + 'M11.2 2.8h1.6v3.8h-1.6z'
      + 'M8.8 10.6 11 13.4H6.6z M15.2 10.6 17.4 13.4H13z'
      + 'M8 15.8h8l-1.6 2.2H9.6z',
    holes: true,
  },
};

/**
 * پیشوندهای واژگانِ 0064 که فقط سلسله‌مراتب رو می‌گن، نه خودِ چیز رو:
 * `music-rock` همون «راک» است.
 */
const PREFIXES = ['music-', 'sports-', 'arts-', 'community-', 'nightlife-', 'games-'];

/** املاهای دیگر همان مفهوم — بیشترشان از واژگانِ هشتگ می‌آیند. */
const ALIASES: Record<string, string> = {
  'hip-hop': 'hiphop',
  'soul-rnb': 'rnb',
  'world-music': 'world',
  'live-music': 'music',
  'singer-songwriter': 'folk',
  acoustic: 'folk',
  indie: 'rock',
  karaoke: 'pop',
  'open-mic': 'pop',
  tribute: 'music',
  'k-pop': 'pop',
  latin: 'dance',
  reggae: 'music',
  art: 'arts',
  expo: 'exhibition',
  'museum-history': 'exhibition',
  'kids-family': 'family',
  'workshop-class': 'workshop',
  'talk-lecture': 'conference',
  networking: 'conference',
  games: 'boardgames',
  nye: 'holiday',
  volunteer: 'community',
  charity: 'community',
  'cultural-heritage': 'world',
};

/**
 * شکلِ یه slug، یا `null` اگه شکلی براش نداریم.
 *
 * ترتیبِ تلاش: خودِ slug → املای هم‌معنی → بدونِ پیشوند → خودِ پیشوند
 * (یعنی `music-newgenre` که هنوز آیکون نداره، دستِ‌کم نتِ موسیقی می‌گیره).
 * `null` که برگشت، هر اپ آیکونِ «برچسب»ِ خودشو می‌ذاره — همون قاعده‌ی
 * همیشگی: آیکونِ نداشته بهتر از آیکونِ اشتباهه.
 */
export function categoryShape(slug?: string | null): CategoryShape | null {
  if (!slug) return null;
  const direct = CATEGORY_SHAPES[slug] ?? CATEGORY_SHAPES[ALIASES[slug] ?? ''];
  if (direct) return direct;
  for (const p of PREFIXES) {
    if (!slug.startsWith(p)) continue;
    const base = slug.slice(p.length);
    const hit = CATEGORY_SHAPES[base] ?? CATEGORY_SHAPES[ALIASES[base] ?? ''];
    if (hit) return hit;
    return CATEGORY_SHAPES[p.slice(0, -1)] ?? null;
  }
  return null;
}
